var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolkswagenInsurance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 192.756 192.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h192.756v192.756H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.411 16.258c44.115 0 80.087 35.974 80.087 80.153 0 44.048-35.973 80.088-80.087 80.088-44.114 0-80.153-36.04-80.153-80.088-.001-44.18 36.039-80.153 80.153-80.153z",
    fill: "#295ca7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.411 26.433c38.468 0 69.914 31.444 69.914 69.979 0 38.469-31.445 69.847-69.914 69.847S26.499 134.88 26.499 96.411c0-38.534 31.443-69.978 69.912-69.978zM49.605 58.796l25.077 65.055 9.19-23.764H107.964l9.189 23.764 25.34-65.843a60.408 60.408 0 0 0-15.887-13.522l-17.592 48.446H84.199L66.542 44.288c-6.499 3.742-12.21 8.666-16.937 14.508zm102.999 16.346l-28.557 74.508c19.17-10.044 32.363-30.131 32.363-53.238 0-7.484-1.312-14.64-3.806-21.27zm-41.03 79.365l-.195-1.51-15.494-40.175-15.492 40.175-.065 1.248c5.12 1.443 10.503 2.166 16.083 2.166 5.251 0 10.306-.656 15.163-1.904zm-43.982-5.514L39.759 76.455c-2.232 6.236-3.414 12.932-3.414 19.956 0 22.582 12.604 42.406 31.247 52.582zM96.411 36.345c5.251 0 10.437.657 15.361 1.969L96.608 80.262l-15.23-42.013a59.721 59.721 0 0 1 15.033-1.904z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolkswagenInsurance);
export default __webpack_public_path__ + "static/media/volkswagen-insurance.8a4c3fc7d372aba73cc3a5bade7f62cd.svg";
export { ForwardRef as ReactComponent };